import service from '@/utils/request'
export function basicMakerList(param) {
    return service.request({
        method: 'POST',
        url: '/app/productManufacturer/productManufacturerList',
        data: param
    })
}
export function basicMakeradd(param) {
    return service.request({
        method: 'POST',
        url: '/app/productManufacturer/add',
        data: param
    })
}
export function basicMakeredit(param) {
    return service.request({
        method: 'POST',
        url: '/app/productManufacturer/edit',
        data: param
    })
}
export function basicMakerdel(param) {
    return service.request({
        method: 'POST',
        url: '/app/productManufacturer/del',
        data: param
    })
}
export function basicMakerbatchDel(param) {
    return service.request({
        method: 'POST',
        url: '/app/productManufacturer/batchDel',
        data: param
    })
}
export function getProductAllList(param) {
    return service.request({
        method: 'POST',
        url: '/app/productManufacturer/list',
        data: param
    })
}
